import { createAction } from '@reduxjs/toolkit';

export const INIT_CALL_FROM_ACTION_TYPE = 'saga/initiateCallFrom';
export const initiateCallFromAction = createAction(INIT_CALL_FROM_ACTION_TYPE);
